import React, { useEffect, useState, useNavi } from "react";
import { APIURL, APIURLCOT } from "../Config";
import { Modal } from "react-bootstrap";
import MapContainer from "../Components/Stp/Page/MapContainer";
import moment from "moment";
import axios from "axios";
import ArticleIcon from "@mui/icons-material/Article";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { toast } from "react-toastify";

function LoanDetails({ lid }) {
  const token = localStorage.getItem("token");
  const loginType = localStorage.getItem("selectedTab");

  const [empData, setEmpData] = useState([]);
  const [mapStatus, setMapStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [clientDetails, setClientDetails] = useState([]);
  const [clientDoc, setClientDoc] = useState([]);
  const [removeList, setRemoveList] = useState([]);
  const [transitionDataMonthly, setTransitionDataMonthly] = useState([]);
  const [transitionHistroy, setTransitionHistroy] = useState([]);
  const [mapValue, setMapValue] = useState("");

  useEffect(() => {
    getClientDetailsMagic(lid);
    // getClientTransactionDetails();
    getTransactionSummery(lid);
    getLoanDetails(lid);
    getClientDetails(lid);
    getClientDoc(lid);
    getRemoveList(lid);
  }, [lid]);

  const getClientDetailsMagic = (loanId) => {
    setIsLoader(true);
    axios
      .request(
        `${
          loginType === "Cashon Tap" ? APIURLCOT : APIURL
        }/loanCardDetails/${loanId}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);
        console.log("response::::", response);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const getRemoveList = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/lateFeeRemovelist/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log(response.data);
        setIsLoader(false);
        setRemoveList(response.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const removeListData = (loanId) => {
    setIsLoader(true);
    console.log(loanId);
    axios
      .request(
        `${
          loginType === "Cashon Tap" ? APIURLCOT : APIURL
        }/lateFeeRemove/${loanId}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        getRemoveList(loanId);
        toast.success("Successfully remove late fee ");
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getClientDoc = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/documentsForReport/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log(response.data);
        setIsLoader(false);
        setClientDoc(response.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const getTransactionSummery = (loanId) => {
    setIsLoader(true);
    axios(
      `${loginType === "Cashon Tap" ? APIURLCOT : APIURL}/SucessTxns/` + loanId,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        let finalArray = [];
        setIsLoader(false);
        console.log("finalArray", finalArray);
        setTransitionHistroy(response.data);
      })

      .catch((error) => {
        console.log("----", error);
        setIsLoader(false);
      });
  };

  const getClientDetails = (loanId) => {
    setIsLoader(true);
    axios
      .request(
        `${
          loginType === "Cashon Tap" ? APIURLCOT : APIURL
        }/getClientMagic/${loanId}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setClientDetails(response?.data);
        setIsLoader(false);
        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const handleModalClose = () => {
    setShowModal(false);
  };
  const groLocation = () => {
    setIsLoader(true);
    axios
      .request(
        `${
          loginType === "Cashon Tap" ? APIURLCOT : APIURL
        }/clientdetails/${lid}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setShowModal(true);
        setIsLoader(false);

        console.log("response", response);
        setMapValue(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getLoanDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/getAllMonthStatement/${loanId}/3`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setTransitionDataMonthly(response.data);

        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  // const getClientTransactionDetails = () => {
  //   axios
  //     .request(`${APIURL}/getAllMonthStatementS/1154430/07`, {
  //       method: "GET",
  //       headers: {
  //Authentication: token,
  //"Content-Type": "application/json",
  //},

  //     })
  //     .then((response) => {
  //       setTranDetails(response?.data);
  //       console.log("TS response::::", response);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  return (
    <>
      <div className="pt-3">
        <div className="card">
          {isLoader ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-success" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="card-body">
              <div className="mt-3">
                <div className="pt-1" style={{ backgroundColor: "#a6df6d" }}>
                  <h5 className="text-center">Profile</h5>
                </div>
                <div className="row ">
                  <div
                    className="col-lg-5 col-md-5 col-sm-12 d-flex mt-5"
                    style={{ justifyContent: "center" }}
                  >
                    <img
                      src={empData?.clientphotourl}
                      className=""
                      height="250px"
                      width="250px"
                    />
                  </div>
                  <div
                    className="col-lg-7 col-md-7 col-sm-12 "
                    style={{ fontSize: "14px" }}
                  >
                    <div className="row mt-4">
                      <b className="col-4 col-xs-6">Name </b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.clientName}
                      </p>
                    </div>
                    <div className="row">
                      <b className="col-4 col-xs-6">Loan Id </b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.loanId}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6">Disbursement Dt</b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.disdate}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6">Mobile</b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.mobileNo}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6">Address</b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.clientaddress}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6 ">Pan No</b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.clientpancard}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6">Email </b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {" "}
                        {empData?.clientEmailId}
                      </p>
                    </div>{" "}
                    <div className="row">
                      <b className="col-4 col-xs-6">Limit</b>
                      <p
                        className="col-8 col-xs-6 mb-1"
                        style={{ fontSize: "16px" }}
                      >
                        {empData?.sanctionAmount}
                      </p>
                    </div>{" "}
                  </div>
                </div>

                <div
                  style={{
                    fontFamily: "PostGrotesk",

                    borderRadius: "10px",
                  }}
                >
                  <div className="row mt-3">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <div
                        className="mb-3"
                        style={{
                          borderRadius: "0px",
                          border: "2px solid #CACACA",
                        }}
                      >
                        <h5 class="p-3 pb-0">Loan Details</h5>
                        <hr />

                        <table
                          class="table table-striped"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <th style={{ border: "none" }}>Loan Id</th>
                              <th style={{ border: "none" }}>
                                {empData.loanId || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Enrollment Id </th>
                              <th style={{ border: "none" }}>
                                {empData?.enrollmentId || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                Sanction Amount{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {empData.sanctionAmount || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Scheme No </th>
                              <th style={{ border: "none" }}>
                                {empData.schemenumber || "-"}
                              </th>
                            </tr>
                            {/* <tr>
                              <th style={{ border: "none" }}>
                                Borrower KYC Address{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {empData.clientaddress || "-"}
                              </th>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="mt-2"
                        style={{
                          borderRadius: "0px",
                          border: "2px solid #CACACA",
                        }}
                      >
                        <h5 class="p-3 pb-0">Bureau Details</h5>
                        <hr />
                        <table
                          class="table table-striped"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <th style={{ border: "none" }}>EPF Score</th>
                              <th style={{ border: "none" }}>
                                {clientDetails?.score || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                Credit Appraisal
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails?.creditApprisal || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Other Details</th>
                              <th style={{ border: "none" }}>
                                {clientDetails?.otherDetails || "-"}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className=" col-lg-4 col-md-4 col-sm-12">
                      <div
                        className="mb-3"
                        style={{
                          borderRadius: "0px",
                          border: "2px solid #CACACA",
                        }}
                      >
                        <h5 class="p-3 pb-0">Borrower Details</h5>
                        <hr />

                        <table
                          class="table table-striped"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <th style={{ border: "none" }}>App Client Id </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.appClientId || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Name</th>
                              <th style={{ border: "none" }}>
                                {clientDetails.clientName || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Gender</th>
                              <th style={{ border: "none" }}>
                                {clientDetails.gender || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>C/O </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.careOf || "-"}
                              </th>
                            </tr>

                            <tr>
                              <th style={{ border: "none" }}>Date Of Birth</th>
                              <th style={{ border: "none" }}>
                                {clientDetails.dateOfBirth
                                  ? moment(clientDetails.dateOfBirth).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Mobile</th>
                              <th style={{ border: "none" }}>
                                {clientDetails.mobile || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                KYC Aadhar Card{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.kycAadhaarNumber || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>PAN No. </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.pannumber || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Email id </th>
                              <th style={{ border: "none" }}>
                                <div>
                                  {clientDetails.emailid?.split("").length >
                                    15 &&
                                    clientDetails.emailid
                                      ?.split("")
                                      .slice(0, 15)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.emailid?.split("").length >
                                    15 &&
                                    clientDetails.emailid
                                      ?.split("")
                                      .slice(15)
                                      .join("")}
                                </div>
                              </th>
                            </tr>
                            {/* <tr>
                            <th style={{ border: "none" }}>Cibil Score </th>
                            <th style={{ border: "none" }}>
                              {empData.score || "-"}
                            </th>
                          </tr> */}

                            <tr>
                              <th style={{ border: "none" }}>
                                Residence Pincode
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.clientpincode || "-"}
                              </th>
                            </tr>

                            <tr>
                              <th style={{ border: "none" }}>
                                Client Account No
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.clientaccountno || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                Client Bank Name
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.bankname || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Employee Type </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.employeeType || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Employer Name </th>
                              <th style={{ border: "none" }}>
                                <div>
                                  {clientDetails.employerName?.split("")
                                    .length > 15 &&
                                    clientDetails.employerName
                                      ?.split("")
                                      .slice(0, 22)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.employerName?.split("")
                                    .length > 15 &&
                                    clientDetails.employerName
                                      ?.split("")
                                      .slice(22, 44)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.employerName?.split("")
                                    .length > 15 &&
                                    clientDetails.employerName
                                      ?.split("")
                                      .slice(44)
                                      .join("")}
                                </div>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className=" col-lg-4 col-md-4 col-sm-12">
                      <div
                        className="mb-3"
                        style={{
                          borderRadius: "0px",
                          border: "2px solid #CACACA",
                        }}
                      >
                        <h5 class="p-3 pb-0">Account Aggregator</h5>
                        <hr />

                        <table
                          class="table table-striped"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <th style={{ border: "none" }}>
                                Account Aggregator <br /> Name{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                <div>
                                  {clientDetails.accountAggregatorName?.split(
                                    ""
                                  ).length > 15 &&
                                    clientDetails.accountAggregatorName
                                      ?.split("")
                                      .slice(0, 15)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.accountAggregatorName?.split(
                                    ""
                                  ).length > 15 &&
                                    clientDetails.accountAggregatorName
                                      ?.split("")
                                      .slice(15, 45)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.accountAggregatorName?.split(
                                    ""
                                  ).length > 15 &&
                                    clientDetails.accountAggregatorName
                                      ?.split("")
                                      .slice(45)
                                      .join("")}
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                First Month Salary{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.firstMonthSalary || "-"}
                              </th>
                            </tr>{" "}
                            <tr>
                              <th style={{ border: "none" }}>
                                Second Month Salary{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.secondMonthSalary || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                Third Month Salary
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.thirdMonthSalary || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>Account No </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.clientaccountno || "-"}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="mt-2"
                        style={{
                          borderRadius: "0px",
                          border: "2px solid #CACACA",
                        }}
                      >
                        <h5 class="p-3 pb-0">EPF Details</h5>
                        <hr />
                        <table
                          class="table table-striped"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <th style={{ border: "none" }}>
                                Establishment Name{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                <div>
                                  {clientDetails.establishmentName?.split("")
                                    .length > 15 &&
                                    clientDetails.establishmentName
                                      ?.split("")
                                      .slice(0, 15)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.establishmentName?.split("")
                                    .length > 15 &&
                                    clientDetails.establishmentName
                                      ?.split("")
                                      .slice(15, 40)
                                      .join("")}
                                </div>
                                <div>
                                  {clientDetails.establishmentName?.split("")
                                    .length > 15 &&
                                    clientDetails.establishmentName
                                      ?.split("")
                                      .slice(40)
                                      .join("")}
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>EPF Employer </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.epfisemployed || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                EPF Total Amount{" "}
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.epftotalamount || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                EPF Employees Count
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.epfemployeescont || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th style={{ border: "none" }}>
                                EPF Date Of Joining
                              </th>
                              <th style={{ border: "none" }}>
                                {clientDetails.epfdateofjoining || "-"}
                              </th>
                            </tr>
                            {/* <tr>
                                  <th style={{ border: "none" }}>Client Name </th>
                                  <th style={{ border: "none" }}>{empData.clientName || "-"}</th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Account Aggregator Name</th>
                                  <th style={{ border: "none" }}>
                                    {empData.accountAggregatorName ||
                                      "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Current Organisation Name</th>
                                  <th style={{ border: "none" }}>
                                    {empData.currentOrganisationName ||
                                      "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>EPF Name</th>
                                  <th style={{ border: "none" }}>{empData.epfName || "-"}</th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Sim Owner Name</th>
                                  <th style={{ border: "none" }}>
                                    {empData.simOwnerName || "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>First Reference Name</th>
                                  <th style={{ border: "none" }}>
                                    {empData.firstRefName || "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>First Reference Relation</th>
                                  <th style={{ border: "none" }}>
                                    {empData.firstRefRelation || "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>First Reference Contact No</th>
                                  <th style={{ border: "none" }}>
                                    {empData.firstRefMobile || "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Friend Name</th>
                                  <th style={{ border: "none" }}>{empData.friendName || "-"}</th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Friend Contact No</th>
                                  <th style={{ border: "none" }}>
                                    {empData.friendMobileno || "-"}
                                  </th>
                                </tr>
                                <tr>
                                  <th style={{ border: "none" }}>Friend No Of Years</th>
                                  <th style={{ border: "none" }}>
                                    {empData.friendNoOfYears || "-"}
                                  </th>
                                </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div
              className="table-responsive pt-1 mt-3"
              style={{ backgroundColor: "#a6df6d" }}
            >
              <h5 className="text-center">Documents</h5>
            </div>
            <div className="mt-3 d-flex flex-col-3">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  const url = `${APIURL}/salarytapAgreement/${lid}`;
                  window.open(url, "_blank");
                }}
                style={{
                  cursor: "pointer",
                  color: "white",
                }}
              >
                Non-Assured Agreement
              </button>
            </div> */}
              <>
                <div
                  style={{
                    backgroundColor: "#ECECEC",
                    borderRadius: "10px",
                  }}
                >
                  <div
                    className="table-responsive pt-1 "
                    style={{ backgroundColor: "#a6df6d" }}
                  >
                    <h5 className="text-center">Document</h5>
                  </div>
                  <div className="row justify-content-center mt-2 pb-3">
                    {clientDoc &&
                      clientDoc.map((item, i) => (
                        <div
                          className="col-12 col-sm-6 col-md-4 col-lg-2 mb-2"
                          key={i}
                        >
                          {" "}
                          <div
                            className="card shadow-sm rounded-lg d-flex flex-column justify-content-center align-items-center mt-2"
                            style={{
                              height: "150px",
                              backgroundColor: "white",
                            }}
                          >
                            {item.docName === "Terms & Condition" ? (
                              <ArticleIcon
                                style={{ fontSize: "40px", color: "#007bff" }}
                              />
                            ) : item.docName === "Loan Agreement" ? (
                              <PostAddIcon
                                style={{ fontSize: "40px", color: "#17a2b8" }}
                              />
                            ) : item.docName === "Sanction Letter" ? (
                              <ArticleIcon
                                style={{ fontSize: "40px", color: "#28a745" }}
                              />
                            ) : item.docName === "Credit Report" ? (
                              <PostAddIcon
                                style={{ fontSize: "40px", color: "#ffc107" }}
                              />
                            ) : item.docName === "ID Photo" ? (
                              <AccountBoxIcon
                                style={{ fontSize: "40px", color: "#dc3545" }}
                              />
                            ) : item.docName === "kfsUrl" ? (
                              <AccountBoxIcon
                                style={{ fontSize: "40px", color: "#6f42c1" }}
                              />
                            ) : item.docName === "selfie photo" ? (
                              <PersonPinIcon
                                style={{ fontSize: "40px", color: "#fd7e14" }}
                              />
                            ) : (
                              <DescriptionIcon
                                style={{ fontSize: "40px", color: "#6c757d" }}
                              />
                            )}

                            <a
                              href={item.docUrl}
                              className="mt-2 text-primary font-weight-bold"
                              style={{
                                fontSize: "14px",
                                textDecoration: "none",
                              }}
                            >
                              {item.docName === "kfsUrl" ? "KFS" : item.docName}
                            </a>
                          </div>
                        </div>
                      ))}
                    <div className="col-12 col-sm-6 col-md-4 col-lg-2 mb-2">
                      <div
                        className="card shadow-sm rounded-lg d-flex flex-column justify-content-center align-items-center mt-2"
                        style={{
                          height: "150px",
                          backgroundColor: "white",
                        }}
                      >
                        <LocationOnIcon
                          style={{ fontSize: "40px", color: "#007bff" }}
                        />
                        <button
                          className="btn btn-link text-decoration-none text-primary font-weight-bold mt-2"
                          onClick={groLocation}
                        >
                          Geo Location
                        </button>
                      </div>
                    </div>
                    <Modal
                      size="lg"
                      show={showModal}
                      onHide={handleModalClose}
                      style={{ background: "#ffffffc4" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title className="font-weight-bold text-primary">
                          GEOLOCATION
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {console.log("map value::", mapValue)}
                        {mapValue.length > 0 ? (
                          <MapContainer data={mapValue} status={mapStatus} />
                        ) : (
                          <h3>Data not found!</h3>
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </>

              <div>
                <>
                  <div className="card shadow mt-4 border">
                    <div className="card-body">
                      <div className="accordion" id="accordionExample">
                        {transitionDataMonthly.map(
                          (row, index) =>
                            !(
                              row.withdrawamt === 0 &&
                              row.totaldue === 0 &&
                              row.paymentrecived === 0
                            ) && (
                              <div className="accordion-item" key={index}>
                                <h2
                                  className="accordion-header"
                                  id={`heading${index}`}
                                >
                                  <button
                                    className={`accordion-button ${
                                      index === 0 ? "" : "collapsed"
                                    }`}
                                    type="button"
                                    data-toggle="collapse"
                                    data-target={`#collapse${index}`}
                                    aria-expanded={
                                      index === 0 ? "true" : "false"
                                    }
                                    aria-controls={`collapse${index}`}
                                  >
                                    {row?.monthyear}
                                  </button>
                                </h2>
                                <div
                                  id={`collapse${index}`}
                                  className={`accordion-collapse collapse ${
                                    index === 0 ? "show" : ""
                                  }`}
                                  aria-labelledby={`heading${index}`}
                                  data-parent="#accordionExample"
                                >
                                  <div className="accordion-body">
                                    <div className="card-text">
                                      <table
                                        className="table mt-3"
                                        style={{ tableLayout: "fixed" }}
                                      >
                                        <tbody>
                                          <tr>
                                            <td>Withdrawals</td>
                                            <td>Rs. {row?.withdrawamt}</td>
                                          </tr>

                                          <tr>
                                            <td>Conv fees incl GST</td>

                                            <td>Rs. {row?.convgst} </td>
                                          </tr>
                                          <tr>
                                            <td>Late Fees</td>

                                            <td>Rs. {row?.latefee} </td>
                                          </tr>
                                          <tr>
                                            <td>Total Due</td>

                                            <td>Rs. {row?.totaldue} </td>
                                          </tr>
                                          <tr>
                                            <td>Payments</td>

                                            <td>Rs. {row?.paymentrecived} </td>
                                          </tr>
                                          <tr>
                                            <td>Balance Due</td>

                                            <td>Rs. {row?.balancedue}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                </>
              </div>
              <div
                className="table-responsive pt-1 mt-3"
                style={{ backgroundColor: "#a6df6d" }}
              >
                <h5 className="text-center">Late Fee</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>S No.</th>
                      <th style={{ textAlign: "center" }}>Loan Id</th>
                      <th style={{ textAlign: "center" }}>Amount</th>
                      <th style={{ textAlign: "center" }}>Due Date</th>
                      <th style={{ textAlign: "center" }}>Late Fee</th>
                      <th style={{ textAlign: "center" }}>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {removeList.map(
                      (row, index) =>
                        row?.SucessAmount !== 0 && (
                          <tr key={index}>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                                width: "100px",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.loanID}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.amount}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.dueDate}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.lateFee}
                            </td>
                            <td>
                              <div>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    removeListData(row?.loanID);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </div>
              <div
                className="table-responsive pt-1 mt-3"
                style={{ backgroundColor: "#a6df6d" }}
              >
                <h5 className="text-center">Transaction Summary</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>S No.</th>
                      <th style={{ textAlign: "center" }}>Date Time</th>
                      <th style={{ textAlign: "center" }}>Payee</th>
                      <th style={{ textAlign: "center" }}>Withdrawal</th>
                      <th style={{ textAlign: "center" }}>Payment</th>
                      <th style={{ textAlign: "center" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transitionHistroy.map(
                      (row, index) =>
                        row?.SucessAmount !== 0 && (
                          <tr key={index}>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                                width: "100px",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.Date}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.Name}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.SucessAmount}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.tag || 0}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                whiteSpace: "normal",
                                fontSize: "14px",
                              }}
                            >
                              {row?.Status}
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default LoanDetails;
